"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignAction = void 0;
var CampaignAction;
(function (CampaignAction) {
    CampaignAction["CreateTeam"] = "CreateTeam";
    CampaignAction["IndividualFundraising"] = "IndividualFundraising";
    CampaignAction["JoinTeam"] = "JoinTeam";
})(CampaignAction || (exports.CampaignAction = CampaignAction = {}));
